import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4ddceb57&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Logo.vue?vue&type=style&index=1&id=4ddceb57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddceb57",
  null
  
)

export default component.exports